module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.clinic.step_title')))]), _vm._v(" "), _c('step-bar', {
    attrs: {
      "currentStep": _vm.currentStepNumber,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoStep
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_address')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_schedule')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_services')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_doctors')))])])], 1), _vm._v(" "), (_vm.clinicReady) ? _c('div', {
    staticClass: "component-wrapper"
  }, [_c(_vm.currentStep, {
    tag: "component",
    attrs: {
      "clinic": _vm.clinic
    },
    on: {
      "update:clinic": function($event) {
        _vm.clinic = $event
      },
      "finishStep": _vm.finishStep,
      "cancelChange": _vm.cancelChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.clinic.create_clinic_success')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddd2925a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/steps/Clinic.vue
// module id = 1054
// module chunks = 1